<template>
  <div class="row" style="height: 90%">
    <div class="col-12" v-if="step == 1">
      <div class="row h-100">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <span>RFIDs (csv)</span>
          <el-upload
            class="d-inline"
            action=""
            :auto-upload="false"
            :file-list="fileList"
            :show-file-list="false"
            :on-change="handleUpload"
            accept=".csv"
          >
            <el-button size="small" class="btn-secondary"
              >Click to upload</el-button
            >
          </el-upload>
          <div class="my-3 d-flex flex-column">
            <div
              v-for="(file, index) in fileList"
              :key="file.uid"
              class="row my-1 text-left"
            >
              <div class="col-6 d-flex align-items-center">
                <p class="mb-0">
                  <small>{{ file.name }}</small>
                </p>
              </div>
              <div class="col-5">
                <div class="input-group">
                  <el-input
                    disabled
                    readonly
                    :value="file.collection_name"
                    size="small"
                  />
                </div>
              </div>
              <div class="col-1">
                <el-button
                  class="py-1 text-navy"
                  type="text"
                  @click="onDelete(index)"
                  icon="el-icon-close"
                >
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <textarea
            v-model="rfidList"
            class="w-100 h-100"
            rows="6"
            placeholder="Copy and paste RFIDs into this box"
            @paste="onListChange"
            @input="onListChange"
          ></textarea>
          <small class="text-grey"
            >Enter RFIDs separated by comma or newline</small
          >
        </div>
      </div>
    </div>
    <div v-if="step == 2" class="col-12">
      <div class="my-3 d-flex flex-column">
        <div
          v-for="(file, index) in fileList"
          :key="file.uid"
          class="row my-1 text-left"
        >
          <div class="col-6 d-flex align-items-center">
            <p class="mb-0">
              <small>{{ file.name }}</small>
            </p>
          </div>
          <div class="col-5">
            <div class="input-group">
              <el-input
                disabled
                readonly
                :value="file.collection_name"
                size="small"
              />
            </div>
          </div>
          <div class="col-1">
            <el-button
              class="py-1 text-navy"
              type="text"
              @click="onDelete(index)"
              icon="el-icon-close"
            >
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CsvParser from "@/backend/mixins/csv-parser";
export default {
  mixins: [CsvParser],
  props: {
    rfidData: {
      type: Object,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  data: () => ({
    step: 1,
    fileList: [],
    rfidList: "",
    loading: false,
    csvData: [],
    csvHeaders: [],
    rfidHeader: "",
    weightHeader: "",
    picHeader: "",
    csvOptions: ["rfid"],
    fileResults: [],
  }),
  mounted() {
    this.fileList =
      this.rfidData != null && this.rfidData.file ? [this.rfidData.file] : [];
    this.rfidList =
      this.rfidData != null && this.rfidData.list ? this.rfidData.list : "";
  },
  methods: {
    onListChange(evt) {
      console.log(this.rfidList);
      let options = [];
      if (this.rfidList.trim()) {
        options = this.rfidList.trim().replace(/\n/g, ",").split(",");
        if (options.length > 0) {
          options = options.map((element) => {
            return element.trim();
          });
          options = ["rfid"].concat(options);
          let csv = options.join("\n");

          let file = {
            raw: new Blob([csv], { type: "text/csv" }),
            collection_name: "nlis_file_(rfid's)",
            name: "RFIDs.csv",
            rfidHeader: "rfid",
          };
          this.fileList = [file];
          this.$emit("updateFile", 1, { file: file, list: this.rfidList });
        }
      }
    },
    handleUpload(file) {
      let self = this;
      this.rfidList = "";
      //   all file uploaded here will be assumed to be an invoice
      file.collection_name = "nlis_file_(rfid's)";

      this.fileList = [file];
      this.parseFile(file.raw, function (results, file) {
        self.fileResults = [...results.meta.fields];
        self.csvData = results.data;
        self.csvHeaders = [...results.meta.fields];
      });
      this.$emit("updateFile", 1, { file: file });
    },
    onDelete(index) {
      this.fileList.splice(index, 1);
      this.rfidList = "";
      this.step = 1;
      this.csvHeaders = [];
      this.csvData = [];
      this.rfidHeader = "";
      this.weightHeader = "";
      this.picHeader = "";
      this.$emit("updateFile", 1);
    },
  },
};
</script>
<style>
.overflow-x-scroll {
  overflow-x: scroll;
}
</style>
